import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
export const LegendContainer = styled.div.withConfig({
  displayName: "Histogramstyles__LegendContainer",
  componentId: "sc-1c3um2o-0"
})(["display:flex;justify-content:space-between;", ";color:", ";padding-top:8px;"], Fonts.regular(12), Colors.GREY_d2d2d2);
export const StyledHistogram = styled.div.withConfig({
  displayName: "Histogramstyles__StyledHistogram",
  componentId: "sc-1c3um2o-1"
})(["display:flex;flex-direction:column;"]);
export const HistogramList = styled.ul.withConfig({
  displayName: "Histogramstyles__HistogramList",
  componentId: "sc-1c3um2o-2"
})(["padding-left:0;height:70px;display:flex;justify-content:space-between;align-items:flex-end;list-style:none;"]);